import { createStore, compose } from 'redux';
import reducers from 'marketing-website/reducers';

export default function configureStore() {
  const notProduction = process.env.NODE_ENV !== 'production';
  const devTools = () => {
    const shouldExposeState = notProduction && window.devToolsExtension;
    return shouldExposeState ? window.devToolsExtension() : f => f;
  };
  return createStore(reducers, compose(devTools()));
}



// WEBPACK FOOTER //
// ./src/redux/createStore.js